import React from 'react';
import { Box } from '@mui/material'; // Only import Box, as Typography and Container are being removed
// IMPORTANT: This import path assumes ExcelUploader.js is in the SAME directory (src/screens)
import ExcelUploader from './ExcelUploader'; // Make sure this path is correct for your setup

const UploadFilePage = () => {
  return (
    // Replaced Container with a Box to fill the available space
    <Box
      sx={{
        flexGrow: 1, // Allows this Box to grow and fill available space within its parent (the DashboardLayout's main content area)
        display: 'flex', // Use flexbox to manage content inside
        flexDirection: 'column', // Stack children vertically
        width: '100%', // Take full width of its parent
        height: '100%', // Take full height of its parent
        bgcolor: 'white', // Set the background of this page to white
        overflow: 'auto', // Add scrolling to this Box if its content (ExcelUploader) overflows
                               // This ensures the page itself can scroll if the table gets too big.
      }}
    >
      {/* The ExcelUploader component is rendered directly inside this Box */}
      <ExcelUploader />
    </Box>
  );
};

export default UploadFilePage;